'use client';

import { Transition, Typography } from 'components';
import { TranslationMemoryClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import Uploader from './_components/Uploader';
import { useTranslationMemoryContext } from './_context/TranslationMemoryContext';

export default function TranslationMemoryPage() {
  const t = useTranslations();
  const router = useRouter();
  const { refetch, hasTerms, isChecking } = useTranslationMemoryContext();

  const handleRefetch = async () => {
    await refetch();
    router.push('/translation-memory/list');
  };

  if (!!hasTerms && !isChecking) return null;

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center pb-10">
      <Transition className="flex h-[200px] flex-col justify-start">
        <TranslationMemoryClipArt />
      </Transition>
      <Transition delay={0.4}>
        <div className="mb-6 max-w-2xl">
          <Typography variant="medium7xl" className="!mt-0 flex text-center text-tertiary-100">
            {t('translation_memory.intro.title')}
          </Typography>
        </div>
        <div className="mb-4 max-w-2xl">
          <Typography variant="light2" className="m-0 text-tertiary-200">
            <div className="text-center">{t('translation_memory.intro.paragraph.one')}</div>
          </Typography>
        </div>
        <div className="mb-4 max-w-2xl">
          <Typography variant="light2" className="m-0 text-tertiary-200">
            <div className="text-center">{t('translation_memory.intro.paragraph.two')}</div>
          </Typography>
        </div>
        <div className="mb-12 max-w-2xl">
          <Typography variant="light2" className="m-0 text-tertiary-200">
            <div className="text-center">{t('translation_memory.intro.paragraph.three')}</div>
          </Typography>
        </div>
      </Transition>
      <Transition delay={1} className="flex h-[100px] flex-col justify-start">
        <Uploader searchRefetch={handleRefetch} />
      </Transition>
    </div>
  );
}
